/**
 * User table column configuration - responsive design
 */

import { ColumnConfig } from '../hooks/useTablePreferences';

export const userColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 180,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'email',
    label: 'Email',
    defaultWidth: 200,
    minWidth: 180,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'userType',
    label: 'User Type',
    defaultWidth: 120,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'privilege',
    label: 'Privilege',
    defaultWidth: 150,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'twoFactor',
    label: '2FA',
    defaultWidth: 80,
    minWidth: 70,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  // Hidden by default - available via Manage Columns
  {
    key: 'dataAccess',
    label: 'Data Access',
    defaultWidth: 110,
    minWidth: 90,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'licenseNumber',
    label: 'License Number',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'yomanId',
    label: 'Yoman ID',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'subClinic',
    label: 'Sub Clinic',
    defaultWidth: 140,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'timezone',
    label: 'Timezone',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 110,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
